<template>
    <div class="smr-date-picker">
        <el-date-picker
            v-model="data"
            ref="datePickerElement"
            type="date"
            placeholder="Pick a day"
            :appendToBody="false"
            :editable="false"
            popper-class="smr-date-picker__panel"
            :picker-options="datePickerOptions"
            @change="changeHandler"
        >
        </el-date-picker>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [Date, String],
            default: ''
        }
    },
    data() {
        return {
            data: '',
            datePickerOptions: {
                firstDayOfWeek: 1,
                // disabledDate(time) {
                //     return time.getTime() < Date.now();
                // },
            }
        }
    },
    watch: {
        value(newVal) {
            this.data = newVal
        }
    },
    mounted() {
        this.setInitialValue()
        this.$refs.datePickerElement.focus()
        setTimeout(() => {
            this.$refs.datePickerElement.blur()
            this.addListeners()
        }, 10);
    },
    beforeDestroy() {
        this.removeListeners()
    },
    methods: {
        setInitialValue() {
            if(this.value) {
                this.data = this.value
            }
        },
        addListeners() {
            const datePickerPanel = this.$refs.datePickerElement.$el.querySelector('.smr-date-picker__panel')
            datePickerPanel.addEventListener('mousedown', this.clickHandler)
            datePickerPanel.addEventListener('touchstart', this.clickHandler)
        },
        removeListeners() {
            const datePickerPanel = this.$refs.datePickerElement.$el.querySelector('.smr-date-picker__panel')
            datePickerPanel.removeEventListener('mousedown', this.clickHandler)
            datePickerPanel.removeEventListener('touchstart', this.clickHandler)
        },
        changeHandler() {
            this.emitChange()
        },
        clickHandler() {
            // focus input again in between to actually trigger the date change
            this.$refs.datePickerElement.focus()
        },
        emitChange() {
            this.$emit('change', this.data);
        }
    }
}
</script>

<style lang="scss">
    .smr-date-picker {
        .el-date-editor {
            width: 100%;

            .el-input__inner {
                opacity: 0;
                height: 0;
                overflow: hidden;
            }
            .el-input__prefix,
            .el-input__suffix {
                display: none;
            }
        }
        .el-date-picker {
            position: static !important;
            display: block !important;
            transform: none !important;
            opacity: 1 !important;
            margin: 0;
            width: 100%;
            border-color: $color-grey-lighter;
            box-shadow: none;
            color: $color-black;

            &__header {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &__header-label {
                color: $color-black;

                &:nth-child(3) {
                    order: 3
                }
                &:nth-child(4) {
                    order: 2
                }
            }

            .el-picker-panel {
                &__content {
                    width: 100%;
                    margin: 0;
                    padding: 0 16px;
                }

                &__icon-btn {
                    color: $color-grey-dark;
                    font-size: 18px;
                    font-weight: $font-weight-bold;
                    margin-top: 3px;

                    &.el-icon-d-arrow-right,
                    &.el-icon-d-arrow-left {
                        display: none;
                    }

                    &.el-icon-arrow-left {
                        order: 1;
                        margin-right: auto;
                    }
                    &.el-icon-arrow-right {
                        order: 4;
                        margin-left: auto;
                    }
                }
            }

            .el-date-table {
                th {
                    text-align: center;
                    color: $color-black;
                    font-size: 15px;
                    border-color: $color-black-005;
                }
                td {
                    .no-touch &:hover {
                        span {
                            color: $color-yellow;
                        }
                    }
                    &.current {
                        span {
                            background: $color-yellow;
                            color: $color-black !important;
                            font-weight: $font-weight-bold;
                        }
                    }
                    &.today {
                        span {
                            color: $color-black;
                        }
                    }
                    div, 
                    span {
                        pointer-events: none;
                    }
                    span {
                        font-size: 15px;
                        width: 36px;
                        height: 36px;
                        line-height: 36px;
                        transition: all 150ms;
                    }
                    &.disabled {
                        div {
                            background-color: transparent;
                        }
                    }
                }
            }

            .el-month-table,
            .el-year-table {
                td {
                    .no-touch &:hover {
                        .cell {
                            color: $color-yellow;
                        }
                    }
                    .cell {
                        color: $color-black;
                        font-size: 15px;
                        transition: 0.2s;
                    }
                }
            }
        }
    }
</style>